export default class InsertNodeController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 */
	constructor(
		$uibModalInstance,
	) {
		this.$uibModalInstance = $uibModalInstance;

		/** @type {any[]} */
		this.node = [];
	}

	/**
	 * @returns {Promise<void>}
	 */
	async insert() {
		return this.$uibModalInstance.close(this.node[0]);
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
